"use client";

import { motion } from "framer-motion";
import { ArrowRight, Shield, Zap, Check } from "lucide-react";
import { fadeUp, scaleIn, Section, img } from "./utils";

export function BottomCTA() {
  return (
    <Section className="px-6 py-20 max-w-7xl mx-auto">
      <motion.div
        variants={scaleIn}
        className="relative overflow-hidden rounded-3xl border border-surface-border"
      >
        <div className="absolute inset-0">
          <img
            src={img.dubaiSkyline}
            alt=""
            className="w-full h-full object-cover opacity-[0.08]"
          />
          <div className="absolute inset-0 bg-surface/80" />
        </div>

        <div
          className="absolute inset-0 pointer-events-none"
          aria-hidden="true"
        >
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[400px] rounded-full blur-[120px]"
            style={{
              background:
                "radial-gradient(circle, rgba(222,115,86,0.12) 0%, transparent 70%)",
            }}
          />
        </div>

        <div className="relative z-10 px-8 py-20 sm:px-16 sm:py-28 text-center">
          <motion.h2
            variants={fadeUp}
            custom={0}
            className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-content"
          >
            How much revenue slipped away this month?
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={1}
            className="mt-5 text-content-secondary max-w-lg mx-auto text-base leading-relaxed"
          >
            Every slow response, missed follow-up, and stalled deal is money
            left on the table. Your AI crew is ready to pick it all up — today.
          </motion.p>
          <motion.div variants={fadeUp} custom={2} className="mt-10">
            <button className="group bg-coral-500 hover:bg-coral-400 text-white font-semibold rounded-full px-10 py-4 text-base transition-all duration-300 active:scale-95 shadow-xl shadow-coral-500/25 hover:shadow-2xl hover:shadow-coral-500/40 cursor-pointer">
              Hire Your AI Team — Free for 14 Days
              <ArrowRight
                size={18}
                className="inline ml-2 group-hover:translate-x-0.5 transition-transform"
              />
            </button>
          </motion.div>
          <motion.div
            variants={fadeUp}
            custom={3}
            className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-6 text-xs text-content-muted"
          >
            <span className="flex items-center gap-1.5">
              <Shield size={14} className="text-content-muted" />
              No credit card required
            </span>
            <span className="flex items-center gap-1.5">
              <Zap size={14} className="text-content-muted" />
              Live in under an hour
            </span>
            <span className="flex items-center gap-1.5">
              <Check size={14} className="text-content-muted" />
              Cancel anytime
            </span>
          </motion.div>
        </div>
      </motion.div>
    </Section>
  );
}
